import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const tabanPortalUrl = process.env.REACT_APP_TABAN_PORTAL_URL || 'https://taban.so';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/download', label: 'Download' },
  { to: '/login', label: 'Sign in' },
];

export default function PublicLayout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#131313] text-white">
      <div className="fixed inset-x-0 top-0 z-40 px-4 py-4 sm:px-6">
        <div className="mx-auto max-w-7xl">
          <header className="rounded-[2rem] border border-[#ffcc00]/18 bg-[linear-gradient(135deg,#1c1b1b,#131313)] px-4 py-3 shadow-[0_22px_70px_rgba(0,0,0,0.4)] backdrop-blur">
            <div className="flex items-center justify-between gap-3">
              <Link to="/" className="flex items-center gap-3" onClick={() => setMenuOpen(false)}>
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#ffcc00] text-lg font-black text-[#131313]">
                  S
                </div>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#ffe8a8]/75">
                    Verified identity
                  </p>
                  <p className="text-lg font-black tracking-[-0.03em] text-white">Shimbirr</p>
                </div>
              </Link>

              <nav className="hidden items-center gap-2 md:flex">
                {navItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className={({ isActive }) =>
                      [
                        'rounded-full px-4 py-2 text-sm font-semibold transition',
                        isActive ? 'bg-[#ffcc00] text-[#131313]' : 'text-[#f0ead8] hover:bg-white/10 hover:text-white',
                      ].join(' ')
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
                <NavLink
                  to="/register"
                  className={({ isActive }) =>
                    [
                      'rounded-full px-4 py-2 text-sm font-semibold transition',
                      isActive
                        ? 'bg-[#ff6d00] text-white'
                        : 'border border-[#ff6d00]/35 bg-[#ff6d00]/10 text-[#ffd4b7] hover:bg-[#ff6d00]/15',
                    ].join(' ')
                  }
                >
                  Create account
                </NavLink>
                <a
                  href={tabanPortalUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full bg-[#ff6d00] px-4 py-2 text-sm font-semibold text-white transition hover:brightness-105"
                >
                  Open Taban
                </a>
              </nav>

              <button
                type="button"
                onClick={() => setMenuOpen((current) => !current)}
                className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/10 text-lg text-white md:hidden"
                aria-label="Toggle menu"
                aria-expanded={menuOpen}
              >
                {menuOpen ? '×' : '☰'}
              </button>
            </div>

            {menuOpen ? (
              <div className="mt-4 grid gap-2 border-t border-white/10 pt-4 md:hidden">
                {navItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      [
                        'rounded-full px-4 py-3 text-sm font-semibold transition',
                        isActive ? 'bg-[#ffcc00] text-[#131313]' : 'bg-white/8 text-white',
                      ].join(' ')
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
                <NavLink
                  to="/register"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    [
                      'rounded-full px-4 py-3 text-sm font-semibold transition',
                      isActive
                        ? 'bg-[#ff6d00] text-white'
                        : 'border border-[#ff6d00]/35 bg-[#ff6d00]/10 text-[#ffd4b7]',
                    ].join(' ')
                  }
                >
                  Create account
                </NavLink>
                <a
                  href={tabanPortalUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full bg-[#ff6d00] px-4 py-3 text-center text-sm font-semibold text-white"
                >
                  Open Taban
                </a>
              </div>
            ) : null}
          </header>
        </div>
      </div>

      <div className="h-28" aria-hidden />
      <div className="relative z-10">{children}</div>

      <footer className="px-4 pb-8 pt-2 sm:px-6">
        <div className="mx-auto max-w-7xl rounded-full border border-[#ffcc00]/12 bg-[#1c1b1b] px-6 py-4 text-center text-sm text-[#d5c8aa] backdrop-blur">
          One Shimbirr identity for trusted access, suite approvals, social messaging, and the wider Taban experience.
        </div>
      </footer>
    </div>
  );
}
